import { sortOptionsISelect } from "../helpers/sortISelect";
import { JobType } from "../model/enumerations/job-type.model";
import { ISelect } from "../model/iSelect";

export const jobTypeEnum = (): Array<ISelect> => {
  const jobType: Array<ISelect> = [    
    {
      label: "Formal",
      value: JobType.FORMAL,
    },
    {
      label: "Freelance",
      value: JobType.FREELANCER,
    },
    {
      label: "Informal",
      value: JobType.INFORMAL,
    },
    {
      label: "Otro",
      value: JobType.OTHERS,
    },
  ];
  return sortOptionsISelect(jobType);
};
